import React from 'react';

function agruparPorData(movs) {
  const grupos = {};
  for (const m of movs) {
    const d = new Date(m.data);
    const key = d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
    if (!grupos[key]) grupos[key] = [];
    grupos[key].push(m);
  }
  return Object.entries(grupos);
}

export default function Historico({ movimentacoes }) {
  if (movimentacoes.length === 0) {
    return <div className="mt"><span className="mt-ico">📋</span>Nenhuma movimentação registrada.</div>;
  }

  const grupos = agruparPorData(movimentacoes.slice(0, 40));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {grupos.map(([data, items]) => (
        <div key={data}>
          <div className="hist-data-label">{data}</div>
          <div className="lst">
            {items.map(m => {
              const isEntrada = m.tipo === 'entrada';
              const valor = (m.quantidade * m.preco_unitario).toFixed(2);
              return (
                <div key={m.id} className="it hist-it">
                  <div className={`hist-tipo-dot ${isEntrada ? 'hist-dot-g' : 'hist-dot-r'}`}>
                    {isEntrada ? '↑' : '↓'}
                  </div>
                  <div className="it-main">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap' }}>
                      <strong style={{ fontSize: 13 }}>{m.produto_nome}</strong>
                      {m.cliente_nome && (
                        <span style={{ fontSize: 11, color: 'var(--c4)' }}>· 👤 {m.cliente_nome}</span>
                      )}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--c4)', marginTop: 2 }}>
                      {isEntrada ? 'Entrada de estoque' : 'Venda'} · {new Date(m.data).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 13, color: isEntrada ? 'var(--y)' : 'var(--g)' }}>
                      {isEntrada ? '−' : '+'} R$ {valor}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--c4)', marginTop: 1 }}>{m.quantidade} un.</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
